import React from "react";
import { Link } from "react-router-dom";

// Text-first empty state — big fist glyph, plain-language guidance, one clear action.
export default function EmptyState({ title, body, actionLabel, actionTo, onAction, testId, glyph = "✊", children }) {
  return (
    <div className="border border-dashed border-[var(--bhega-border-strong)] bg-card px-6 py-12 text-center" data-testid={testId}>
      <div className="text-4xl" aria-hidden>{glyph}</div>
      <h3 className="mt-3 text-lg font-extrabold">{title}</h3>
      {body && <p className="text-sm text-muted-foreground mt-1.5 max-w-md mx-auto">{body}</p>}
      {actionLabel && (actionTo
        ? <Link to={actionTo} className="btn-primary mt-5">{actionLabel}</Link>
        : <button onClick={onAction} className="btn-primary mt-5">{actionLabel}</button>)}
      {children && <div className="mt-5">{children}</div>}
    </div>
  );
}
